import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { IGlobalStoreReducers } from './ReduxStore';

export interface ISearchState {
    isOnSearch: boolean;
}

const initialState: ISearchState = {
    isOnSearch: false,
};

const reducers = {
    changeIsOnSearch: (state: ISearchState, action: PayloadAction<boolean>) => {
        state.isOnSearch = action.payload;
    },
};

export const searchSlice = createSlice({
    name: 'searchState',
    initialState,
    reducers,
});

export const isOnSearchState = (state: IGlobalStoreReducers) => state.searchState.isOnSearch;

export const { changeIsOnSearch } = searchSlice.actions;

export default searchSlice.reducer;
